/* Ruby Rose — "Handpicked for you".

   The section is rendered again through the Section Rendering API to get a
   real pool of products, then trimmed here:

     1. drop the product's own shade family — someone looking at one blush does
        not want the same blush in nine other shades;
     2. keep one card per family, so five cards mean five different products
        rather than five shades of one;
     3. if the narrow category is too thin to fill the row (Mascaras has a
        single family, Foundations two), top up from the broad category.

   Steps 1-2 run in the browser because the pooled render is a collection
   request and cannot know which product the shopper came from. */

(function () {
  const parser = new DOMParser();

  function fetchInner(url) {
    return fetch(url)
      .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
      .then((html) => parser.parseFromString(html, "text/html").querySelector("[data-rr-hand-inner]"))
      .catch(() => null);
  }

  /** Move acceptable cards out of `inner` into `kept`, newest-last. */
  function harvest(inner, kept, seen, exclude, limit) {
    if (!inner) return;
    const track = inner.querySelector("[data-rr-track]");
    if (!track) return;

    [...track.querySelectorAll("[data-rr-card]")].forEach((card) => {
      if (kept.length >= limit) return;
      const family = card.getAttribute("data-rr-family") || "";
      if (family !== "" && (family === exclude || seen.has(family))) return;
      if (family !== "") seen.add(family);
      kept.push(card);
    });
  }

  async function load(root) {
    const url = root.getAttribute("data-rr-hand-url");
    if (!url || root.dataset.rrHandLoaded) return;
    root.dataset.rrHandLoaded = "1";

    const fallbackUrl = root.getAttribute("data-rr-hand-fallback");
    const exclude = root.getAttribute("data-rr-hand-exclude") || "";
    const limit = parseInt(root.getAttribute("data-rr-hand-limit"), 10) || 10;
    const min = parseInt(root.getAttribute("data-rr-hand-min"), 10) || 5;

    const kept = [];
    const seen = new Set();

    let shell = await fetchInner(url);
    harvest(shell, kept, seen, exclude, limit);

    // Only pay for the second request when the narrow category came up short.
    if (kept.length < min && fallbackUrl) {
      const extra = await fetchInner(fallbackUrl);
      harvest(extra, kept, seen, exclude, limit);
      if (!shell || !shell.querySelector("[data-rr-track]")) shell = extra;
    }

    const target = root.querySelector("[data-rr-hand-inner]");
    if (!target || !shell || kept.length === 0) {
      root.hidden = true;
      return;
    }

    const track = shell.querySelector("[data-rr-track]");
    track.replaceChildren(...kept);

    // outerHTML so the markup is parsed by *this* document — that is what
    // upgrades <ruby-carousel> and wires its arrows.
    target.outerHTML = shell.outerHTML;
  }

  function init() {
    document.querySelectorAll("[data-rr-hand-url]").forEach(load);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  // The theme editor re-renders sections in place.
  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll?.("[data-rr-hand-url]").forEach(load);
  });
})();
